import { z } from 'zod';

export const contactEmail = 'contact@addava.com';
const singleLine = z
  .string()
  .trim()
  // eslint-disable-next-line no-control-regex -- Reject control characters in email header fields.
  .regex(/^[^\r\n\u0000-\u001f\u007f]*$/, 'Use a single line.');
export const contactFormSchema = z.object({
  name: singleLine.min(1, 'Enter your name.').max(200, 'Use 200 characters or fewer.'),
  email: singleLine.max(254).pipe(z.email('Enter a valid email address.')),
  message: z.string().trim().min(1, 'Enter a message.').max(5000, 'Use 5,000 characters or fewer.'),
  website: z.string().max(200),
});
export const contactSubmissionSchema = contactFormSchema
  .extend({ submissionId: z.uuid() })
  .strict();

// The homepage's walkthrough request. It goes to the same fixed inbox as a contact
// message; `kind` keeps the two shapes apart at the backend.
export const walkthroughRoles = ['pm', 'owner', 'other'] as const;
export const walkthroughRoleLabels: Record<(typeof walkthroughRoles)[number], string> = {
  pm: 'Property manager',
  owner: 'Owner or operator',
  other: 'Something else',
};
export const portfolioSizes = ['Under 100', '100 to 499', '500 to 1,999', '2,000 or more'] as const;
export const walkthroughFormSchema = z.object({
  role: z.enum(walkthroughRoles),
  name: contactFormSchema.shape.name,
  email: contactFormSchema.shape.email,
  // Any common way of writing a number with its area code: digits, spaces, + ( ) . - and an
  // extension, at least ten digits in all.
  phone: singleLine
    .max(40, 'Use 40 characters or fewer.')
    .regex(/^[0-9+().\-\s]*(?:(?:x|ext\.?)\s*[0-9]+)?$/i, 'Use digits and + ( ) - only.')
    .refine(
      (value) => value.replace(/[^0-9]/g, '').length >= 10,
      'Add a phone number with area code so we can reach you.',
    ),
  company: singleLine.min(1, 'Enter your company.').max(200, 'Use 200 characters or fewer.'),
  doors: z.enum(portfolioSizes, { error: 'Required' }),
  where: singleLine.max(500, 'Use 500 characters or fewer.'),
  what: z.string().trim().max(5000, 'Use 5,000 characters or fewer.'),
  website: contactFormSchema.shape.website,
});
export const walkthroughSubmissionSchema = walkthroughFormSchema
  .extend({ kind: z.literal('walkthrough'), submissionId: z.uuid() })
  .strict();
